import * as moment from "moment";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";

import { ListedJob } from "@common/api/v1.1/types/jobs";

type Props = Readonly<{
  active: boolean;
  job: ListedJob;
  onAbort?: () => void;
}>;

export const Job = ({ active, job, onAbort }: Props) => {
  const classes = useMemo(() => {
    const toReturn = [
      "align-items-center",
      "d-flex",
      "job",
      "justify-content-between",
      "list-group-item",
      "list-group-item-action",
    ];
    if (active) {
      toReturn.push("active");
    }
    return toReturn.join(" ");
  }, [active]);
  const jobDate = useMemo(() => moment.unix(job.date_created).format("MMM D, YYYY h:mm A"), [
    job.date_created,
  ]);
  const claimedBy = useMemo(() => {
    if (job.claimed_by) {
      return (
        <div className="align-items-center d-flex">
          <div className="flex-fill text-truncate">Claimed by: {job.claimed_by.name}</div>
          {onAbort && (
            <Button
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                if (
                  !active ||
                  window.confirm(
                    "Are you sure you want to abort this job? You will lose any unsaved progress.",
                  )
                ) {
                  onAbort();
                }
              }}
              size="sm"
              type="button"
            >
              Abort
            </Button>
          )}
        </div>
      );
    }
    return null;
  }, [active, job.claimed_by, onAbort]);
  return (
    <Link to={`/job/${job.id}`} className={classes} title={job.name}>
      <div className="flex-fill overflow-hidden">
        <div className="lead mb-0 text-truncate">
          <strong className={active ? "text-white" : "text-primary"}>{job.name}</strong>
        </div>
        <div className="text-truncate">
          <small>
            <i aria-hidden="true" className="fa fa-calendar" /> {jobDate}
          </small>
        </div>
        {claimedBy}
      </div>
      <div className="text-center" style={{ minWidth: "20px" }}>
        <i className="fa fa-angle-right" />
      </div>
    </Link>
  );
};
Job.displayName = "Job";
